import React, {useState} from "react";
import { BentoGrid, BentoGridItem } from "./ui/BentooGrid";
import { CopyCheck, CopyIcon, Linkedin } from "lucide-react";
import MagicButton from './ui/MagicButton' ;
import { Globe } from "./ui/globe";
import MapWidget from "./ui/MapWidget";
import {
  IconArrowWaveRightUp,
  IconBoxAlignRightFilled,
  IconBoxAlignTopLeft,
  IconSignature,
  IconTableColumn,
} from "@tabler/icons-react";
import InfiniteCards from "./ui/InfiniteCards";

const Dashboarding = () => {
  return (
    <section id="Dashboard" className="bg-gray-900 pt-5 pb-5">
    <BentoGrid className="bg-gray-900 max-w-6xl mx-auto pt-5 pb-5">
      {items.map((item, i) => (
        <BentoGridItem
          key={i}
          title={item.title}
          description={item.description}
          header={item.header}
          icon={item.icon}
          className={item.id === 4 || item.id === 2 ? "md:col-span-2 " + item.className : item.className}
        />
      ))}
    </BentoGrid>
    </section>
  );
}

const Publications = () => {
  const pubItems = [
    {
      title: "Patent # 11438289",
      status: "Published",
      statusColor: "bg-green-100 text-green-800",
      dueDate: "September 2023",
      createdBy: "Justia Patents",
      link: "https://patents.justia.com/patent/11438289",
    },
    {
      title: "Patent # 11128589",
      status: "Published",
      statusColor: "bg-green-100 text-green-800",
      dueDate: "July 2021",
      createdBy: "Justia Patents",
      link: "https://patents.justia.com/patent/11128589",
    },
    {
      title: "Genetic Algorithm",
      status: "Published",
      statusColor: "bg-green-100 text-green-800",
      dueDate: "July 2024",
      createdBy: "AIWARE 2024",
      link: "https://doi.org/10.1145/3664646.3665086",
    },
  ];

  return (
    <div className="w-full bg-transparent">
        <p className="text-white text-center font-bold h5">Publications</p>
      <ul role="list" className="divide-y divide-gray-700">
        {pubItems.map((project, index) => (
          <a
            key={index}
            target="_blank"
            rel="noreferrer"
            href={project.link}
            className="block"
          >
            <li className="flex  items-center justify-center text-center rounded-lg p-3 transition hover:bg-gray-800">
              <div className="flex flex-col">
                <div className="flex flex-wrap items-center gap-2">
                  <h3 className="text-sm md:text-base font-semibold text-white break-words">
                    {project.title}
                  </h3>
                  <span
                    className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${project.statusColor}`}
                  >
                    {project.status}
                  </span>
                </div>
                <p className="text-xs md:text-sm text-gray-400">
                  {project.dueDate} · {project.createdBy}
                </p>
              </div>
            </li>
          </a>
        ))}
      </ul>
    </div>
  );
};

const EmailBlock = () => {
    const [copied, setCopied] = useState(false);
    
    const handleCopy = () => {
    const text = "vigneshwaran.dharmalingam@gmail.com";
        navigator.clipboard.writeText(text);
        setCopied(true);
    };
    return (
        <div className="flex flex-col items-center justify-center space-y-6 text-center relative">
            {/* Title */}
            <p className="font-bold text-white text-lg md:text-xl">
                Do you want to start a project together?
            </p>

            {/* LinkedIn Icon */}
            <a
                target="_blank"
                rel="noreferrer"
                href="https://www.linkedin.com/in/vigneshwaran-dharmalingam/"
                className="text-white hover:text-blue-400 transition"
            >
                <Linkedin size={60} />
            </a>

            {/* Magic Button */}
            <MagicButton
                title={copied ? "Email is Copied!" : "Copy my Email"}
                icon={copied ? <CopyCheck /> : <CopyIcon />}
                position="left"
                handleClick={handleCopy}
                otherClasses="!bg-[#161A31]"
            />
            </div>

    );
}

const GlobeComponent = () => {
    return (
    <div className="w-full h-full p-2 relative flex justify-between space-y-6 rounded-2xl bg-gradient-to-br from-neutral-900 to-neutral-800 overflow-hidden">
        {/* Text on left */}
        <div className="z-9 p-2 w-1/2">
            <h2 className="text-xl text-left font-bold text-white mb-2">Time Zone</h2>
            <p className="text-lg text-left text-gray-400">
            I'm based in the US, and open to remote work worldwide
            </p>
        </div>

        {/* Globe on right, anchored bottom */}
        <div className="absolute right-0 top-0 w-1/2 h-full flex items-center justify-center">
            <Globe />
        </div>
        </div>
  );
}

const items = [
  {
    id: 1,
    header: <div className="relative w-full h-full">
        {/* Background Image */}
        <img
            src="./assets/new/b1.svg"
            alt="Collaboration"
            className="absolute inset-0 h-full w-full object-cover rounded-xl"
        />
        {/* Overlay Title */}
        <div className="absolute -bottom-6 w-full p-4 bg-gradient-to-t from-black/60 to-transparent rounded-b-xl text-start">
            <h3 className="text-white font-bold text-lg md:text-lg">
            I prioritize client collaboration, fostering open communication
            </h3>
        </div>
        </div>
  },
  {
    id: 5,
    // title: "Publications",
    // description: "Join the quest for understanding and enlightenment.",
    header: <Publications />,
    icon: <IconArrowWaveRightUp className="h-4 w-4 text-neutral-500" />,
    className: 'p-3 overflow-y-auto'
  },
  {
    id: 3,
    header: <MapWidget />,
    icon: <IconSignature className="h-4 w-4 text-neutral-500" />,
    className: ''
  },
  {
    id: 4,
    title: "My Tech Stack",
    // description:
    //   "Understand the impact of effective communication in our lives.",
    header: <InfiniteCards />,
    icon: <IconTableColumn className="h-4 w-4 text-neutral-500" />,
    className: 'p-4 text-center'
  },
  {
    id: 6,
    // title: "The Joy of Creation",
    // description: "Experience the thrill of bringing ideas to life.",
    header:
        <div className="p-4"> 
            <img
            src="./assets/awsdev.png"
            className="h-full w-full object-contain"
        />
        </div>,
    icon: <IconBoxAlignTopLeft className="h-4 w-4 text-neutral-500" />,
    className: 'p-4'
  },
  {
    id: 7,
    // title: "Do you want to start a project together?",
    // description: "Embark on exciting journeys and thrilling discoveries.",
    header: <EmailBlock />,
    icon: <IconBoxAlignRightFilled className="h-4 w-4 text-neutral-500" />,
    className: 'p-4'
  },
      {
    id: 2,
    // title: "My Tech Stack",
    // description:
    //   "Understand the impact of effective communication in our lives.",
    header: <GlobeComponent />,
    icon: <IconTableColumn className="h-4 w-4 text-neutral-500" />,
    className: 'p-4'
  },
];

export default Dashboarding;